import { type PartialUserContext } from '@common/defaults/UserContext';
import { isClientSide } from '@common/utils/isClientSide';

import { SupertokensStatus } from './SupertokensStatus';

/**
 * @name getCookie
 * @description Private function to get cookie by name to avoid importing js-cookie
 * since this is used in the api as well as web and admin
 * api does not need to know about js-cookie
 * @param name - The name of the cookie to get
 * @returns The value of the cookie
 */
const getCookie = (name: string): string => {
    const cookies = document.cookie ? document.cookie.split(';') : [];
    const found = cookies.find((c) => c.trim().startsWith(`${name}=`));

    if (!found) {
        return '';
    }

    const [_, value] = found.split('=');

    return value;
};

export const updateStatus = (userContext: PartialUserContext | undefined, fromStatusCode?: number) => {
    if (!userContext?.supertokens) {
        return SupertokensStatus.UNKNOWN;
    }

    if (isClientSide) {
        userContext.supertokens.sFrontToken = getCookie('sFrontToken');
    }

    if (!userContext.supertokens.sAccessToken) {
        userContext.supertokens.status = SupertokensStatus.NOT_LOGGED_IN;
    } else if (fromStatusCode === 401) {
        userContext.supertokens.status = SupertokensStatus.NEEDS_REFRESH;
    } else if (userContext.supertokens.status !== SupertokensStatus.NEEDS_REFRESH) {
        // Assume the user is logged in, api will tell us if he/she's not
        userContext.supertokens.status = SupertokensStatus.LOGGED_IN;
    }

    return userContext.supertokens.status;
};
